"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContainer = exports.useManager = exports.ModalManagerProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const removeChildContainer = (element) => document.body.contains(element) && document.body.removeChild(element);
const scrollbarWidth = () => {
    if (document.documentElement.scrollHeight <= document.documentElement.clientHeight)
        return 0;
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    const width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    removeChildContainer(scrollDiv);
    return width;
};
const getPaddingRight = (container) => {
    const padding = container.style.paddingRight;
    const width = scrollbarWidth();
    return padding ? `calc(${padding} + ${width}px)` : `${width}px`;
};
class ModalManager {
    constructor() {
        this.refs = [];
        this.bodyStyle = {
            overflow: '',
            paddingRight: '',
        };
        this.applyStyleToBody = (style) => {
            const values = {
                overflow: 'hidden',
                paddingRight: getPaddingRight(this.body),
            };
            this.bodyStyle[style] = this.body.style[style];
            this.body.style[style] = values[style];
        };
        this.restoreStyleToBody = (style) => {
            if (typeof this.bodyStyle[style] !== 'undefined') {
                this.body.style[style] = this.bodyStyle[style];
                delete this.bodyStyle[style];
            }
        };
        this.getIndex = (ref) => this.refs.indexOf(ref);
        this.styleContainer = () => {
            this.applyStyleToBody('overflow');
            this.applyStyleToBody('paddingRight');
        };
        this.restoreContainer = () => {
            this.restoreStyleToBody('overflow');
            this.restoreStyleToBody('paddingRight');
        };
        this.styleModal = (modal, isTop) => {
            modal.style.visibility = isTop ? '' : 'hidden';
        };
        this.setDocumentBody = () => {
            this.body = document.body;
        };
    }
    updateModals() {
        const length = this.refs.length;
        for (let i = 0; i < length; i++) {
            const modal = this.refs[i].current;
            if (modal)
                this.styleModal(modal, i === length - 1);
        }
    }
    add(ref, lockPageScroll) {
        if (this.refs.length === 0 && lockPageScroll)
            this.styleContainer();
        this.refs.push(ref);
        this.updateModals();
    }
    remove(ref) {
        const index = this.getIndex(ref);
        if (index !== -1)
            this.refs.splice(index, 1);
        if (this.refs.length === 0)
            this.restoreContainer();
        this.updateModals();
    }
}
const defaultManager = new ModalManager();
const ModalManagerContext = (0, react_1.createContext)({ manager: defaultManager });
const useManager = ({ open, lockPageScroll = true }) => {
    const ref = (0, react_1.useRef)(null);
    const { manager, container } = (0, react_1.useContext)(ModalManagerContext);
    const [mounted, setMounted] = (0, react_1.useState)(false);
    const onDone = () => {
        setMounted(true);
    };
    (0, react_1.useEffect)(() => {
        manager.setDocumentBody();
    }, []);
    (0, react_1.useEffect)(() => {
        if (!mounted || !ref)
            return;
        if (open)
            manager.add(ref, lockPageScroll);
        else
            manager.remove(ref);
        return () => {
            manager.remove(ref);
        };
    }, [open, ref, mounted]);
    return { ref, onDone, container };
};
exports.useManager = useManager;
const ModalManagerProvider = ({ container, children }) => {
    const manager = defaultManager;
    return (0, jsx_runtime_1.jsx)(ModalManagerContext.Provider, { value: { manager, container }, children: children });
};
exports.ModalManagerProvider = ModalManagerProvider;
const useContainer = (zIndex) => {
    const [container, setContainer] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const topmostContainer = document.createElement('div');
        topmostContainer.style.position = 'fixed';
        topmostContainer.style.zIndex = zIndex;
        document.body.appendChild(topmostContainer);
        setContainer(topmostContainer);
        return () => {
            removeChildContainer(topmostContainer);
        };
    }, []);
    return container;
};
exports.useContainer = useContainer;
